export default __webpack_public_path__ + "static/media/Nikol-Valeri.38c294a3.png";